import { ChangeDetectionStrategy, Component, TemplateRef, computed, contentChild, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalizePipe } from '@shared/pipes/localize.pipe';

export interface RowsSectionColumn {
    labelKey: string;
    colClass: string;
}

export interface RowsSectionRowContext {
    $implicit: number;
}

@Component({
    selector: 'app-rows-section',
    templateUrl: './rows-section.component.html',
    styleUrls: ['./rows-section.component.less'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, LocalizePipe],
})
export class RowsSectionComponent {
    titleKey = input.required<string>();
    columns = input.required<RowsSectionColumn[]>();
    rowsCount = input<number>(0);
    minRows = input<number>(1);
    addLabelKey = input<string>('Add');
    addDisabled = input<boolean>(false);

    addRow = output<void>();
    removeRow = output<number>();

    readonly rowTemplate = contentChild.required<TemplateRef<RowsSectionRowContext>>('row');
    readonly rowIndexes = computed(() => Array.from({ length: this.rowsCount() }, (_, index) => index));
    readonly canRemove = computed(() => this.rowsCount() > this.minRows());
}
